import { FC } from 'react';

import {
  Box,
  List,
  Drawer,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from '@mui/material';

import logo from 'src/assets/logo/logo.png';
import { COLORS } from 'src/online-payment/constants';

import Iconify from 'src/components/iconify';

/* =================== TYPES =================== */
interface NavItem {
  title: string;
  path: string;
  icon: string;
}

/* =================== DRAWER =================== */
interface DrawerProps {
  navItems: readonly NavItem[] | NavItem[];
  isActive: (path: string) => boolean;
  handleNavigation: (path: string) => void;
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
}

const DrawerMenu: FC<DrawerProps> = ({
  navItems,
  isActive,
  handleNavigation,
  mobileOpen,
  handleDrawerToggle,
}) => (
  <Drawer
    anchor="right"
    variant="temporary"
    open={mobileOpen}
    onClose={handleDrawerToggle}
    ModalProps={{
      keepMounted: true,
    }}
    sx={{
      display: { xs: 'block', md: 'none' },
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: 280,
        bgcolor: COLORS.cardBg,
      },
    }}
  >
    <Box sx={{ width: 280, pt: 2 }}>
      {/* LOGO IN DRAWER */}
      <Box
        component="img"
        src={logo}
        alt="PointCraft"
        sx={{
          height: 28,
          width: 'auto',
          px: 2,
          mb: 3,
        }}
      />

      {/* NAVIGATION LIST */}
      <List>
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <ListItem key={item.path} disablePadding>
              <ListItemButton
                onClick={() => handleNavigation(item.path)}
                sx={{
                  mx: 1,
                  borderRadius: 1.5,
                  bgcolor: active ? COLORS.primary : 'transparent',
                  color: active ? COLORS.cardBg : COLORS.textSecondary,
                  '&:hover': {
                    bgcolor: active ? COLORS.primaryHover : COLORS.background,
                  },
                }}
              >
                <ListItemIcon
                  sx={{ color: active ? COLORS.cardBg : COLORS.textSecondary, minWidth: 40 }}
                >
                  <Iconify icon={item.icon} width={20} />
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{
                    fontWeight: active ? 600 : 500,
                    fontSize: '0.95rem',
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  </Drawer>
);

export default DrawerMenu;
